import invoiceProvider from '@/providers/invoice'
export default {
  data() {
    return {
      locationId: Number(this.$route.params.locationId),
      isLoading: false,
      isSaving: false
    }
  },
  computed: {},

  methods: {
    getLocationInvoiceSettings(callback) {
      let self = this
      this.isLoading = true
      invoiceProvider.methods
        .getLocationInvoiceSettings(this.locationId)
        .then(response => {
          if (response.status === 200) {
            callback(response.data)
          }
        })
        .finally(() => {
          self.isLoading = false
        })
    },

    /**
     * Get invoice code example
     * @param {*} number
     * @param {*} numberPadding
     * @param {*} codeTemplate
     * @param {*} code
     */
    getCode(number, numberPadding, codeTemplate, code) {
      let year = new Date().getFullYear()

      codeTemplate = codeTemplate.replace('##locationcode##', code)
      codeTemplate = codeTemplate.replace('##yyyy##', year)
      codeTemplate = codeTemplate.replace(
        '##number##',
        this.getPadNumber(number, numberPadding)
      )
      return codeTemplate
    },

    /**
     * Get pad number
     * @param {String} n
     * @param {Number} width
     * @param {String} z
     */
    getPadNumber(n, width, z) {
      z = z || '0'
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    }
  }
}
